import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appInputDate]'
})
export class InputDateDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
  }
}
